import React, { Component } from 'react';
import _ from 'lodash';

import styles from './InsightCard.scss';

const defaultStyle = {
  lowWidth: 30,
  normalWidth: 40,
  highWidth: 30
};

class AnalysisItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lowWidth: 30,
      normalWidth: 40,
      highWidth: 30,
      lowLabel: '',
      highLabel: '',
      currentLabel: '',
      valueType: '',
      isLoaded: false
    }

    this.chartContainerRef = React.createRef();
    this.currentLabelRef = React.createRef();
  }

  componentDidMount() {
    this.setState({
      isLoaded: false
    });

    if (this.props) {
      this.calculateChartZones();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.values && prevProps.values != this.props.values) {
      this.setState({
        isLoaded: false
      });
      this.calculateChartZones();
    }
  }

  calculateChartZones() {
    if (this.props.values) {
      const { high, currentValue } = this.props.values;
      let low = this.props.values.low;

      let currentValueLabelPercentage = 0;

      if (_.isNumber(low) && _.isNumber(high) && _.isNumber(currentValue)) {
        let lowLabel = `${low.toLocaleString(undefined, { maximumFractionDigits: 1 })}`;
        let highLabel = `${high.toLocaleString(undefined, { maximumFractionDigits: 1 })}`;
        let currentLabel = `${currentValue.toLocaleString(undefined, { maximumFractionDigits: 1 })}`;

        let valueType = !this.props.valueType || this.props.valueType === '%'
          ? ''
          : this.props.valueType;

        if (this.props.valueType === '%') {
          lowLabel = `${lowLabel}%`;
          highLabel = `${highLabel}%`;
          currentLabel = `${currentLabel}%`;
        }

        let { lowWidth,
          highWidth,
          normalWidth } = defaultStyle;

        if (low === high && currentValue !== low) {
          lowWidth = 50;
          highWidth = 50;
          normalWidth = 0;
          highLabel = undefined;
        } else if (low == 0 || low === high) {
          lowWidth = 0;
          normalWidth = 50;
          highWidth = 50;
          lowLabel = undefined;
          low = 0;
        }

        if (currentValue == low) {
          currentValueLabelPercentage = lowWidth;
          lowLabel = undefined;
        }

        if (currentValue == high) {
          currentValueLabelPercentage = lowWidth + normalWidth;
          highLabel = undefined;
        } else if (currentValue < low) {
          currentValueLabelPercentage = currentValue === 0 ? 0 : this.leftAlignment(low, currentValue, 0, lowWidth);
        } else if (currentValue > low && currentValue < high) {
          currentValueLabelPercentage = this.leftAlignment(high, currentValue, low, normalWidth) + lowWidth;
        } else if (currentValue > high) {
          currentValueLabelPercentage = lowWidth + normalWidth + this.leftAlignment(high + low, currentValue, high, highWidth);
        }

        this.setState(
          {
            lowLabel,
            highLabel,
            currentLabel,
            lowWidth,
            normalWidth,
            highWidth,
            currentValuePercentage: currentValueLabelPercentage,
            valueType,
            isLoaded: true
          });
      }
    }
  }

  leftAlignment(max, middle, min, width) {
    const rightDiff = max - middle;
    const leftDiff = middle - min;

    if (rightDiff < leftDiff) {
      return (width / 3) * 2;
    } else if (rightDiff == leftDiff) {
      return width / 2;
    } else { //higher - lower > lower
      return width / 3;
    }
  }

  labelPosition() {

    if (this.currentLabelRef && this.chartContainerRef && _.isNumber(this.state.currentValuePercentage)) {

      const labelElementWidth = this.currentLabelRef.current.getBoundingClientRect().width;
      const chartElementWidth = this.chartContainerRef.current.getBoundingClientRect().width;
      const sideChartMargin = 20;

      const leftOverflowInPx = labelElementWidth / 2 - (((this.state.currentValuePercentage * chartElementWidth) / 100) + sideChartMargin);

      const rightOverflowInPx = labelElementWidth / 2 - ((((100 - this.state.currentValuePercentage) * chartElementWidth) / 100) + sideChartMargin);

      if (leftOverflowInPx > 0) {
        return { transform: `translateX(${leftOverflowInPx}px)` };
      }

      if (rightOverflowInPx > 0) {
        return { transform: `translateX(${-1 * rightOverflowInPx}px)` }
      }
    }
    return {};
  }
  render() {
    return (
      <div className='analysis-process' ref={this.chartContainerRef} style={{ visibility: this.state.isLoaded ? 'visible' : 'hidden'}}>
        {this.state.lowWidth > 0 &&
          <div className='analysis-process-item low' style={{width: this.state.lowWidth + "%"}}>
            {this.state.lowLabel && <div className='name'>
              Low
              <span className='point'></span>
              <span className='line'></span>
            </div>}
            <div className='bg'></div>
            <div className='num-task' title={this.state.lowLabel}>
              <span>{this.state.lowLabel}
                <br />
                {this.state.valueType}
              </span>
            </div>
          </div>
        }
        <div className='analysis-process-item normal' style={{ width: this.state.normalWidth + "%" }}>
          <div className='name'>
            Stable
            <span className='point'></span>
            <span className='line'></span>
          </div>
          <div className='bg'></div>
          {this.state.highLabel && <div className='num-task' title={this.state.highLabel}>
            <span>{this.state.highLabel}
              <br />
              {this.state.valueType}
            </span>
          </div>}
        </div>
        <div className='analysis-process-item high' style={{ width: this.state.highWidth + "%" }}>
          <div className='name'>
            High
            <span className='point'></span>
            <span className='line'></span>
          </div>
          <div className='bg'></div>
        </div>

        <div className={'analysis-process-item current'} style={{ left: this.state.currentValuePercentage + "%" }}>
          <div className='name'>
            <span style={this.labelPosition()} ref={this.currentLabelRef}>
              Your
              <br />
              <i>{this.props.labelText}</i></span>
            <span className='point'></span>
            <span className='line'></span>
          </div>
          <div className='num-task' title={this.state.currentLabel}>
            <span>{this.state.currentLabel}
              <br />
              {this.state.valueType}
            </span>
          </div>
        </div>
      </div>
    )
  }
}

export default AnalysisItem;
